import React, { useEffect } from "react";
import "./auth.css";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../assets/LogoNew2.png";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  CircularProgress,
  Divider,
  Alert,
  Collapse,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import HomeIcon from "@mui/icons-material/Home";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserLogin } from "../../../redux/reducer/LoginUser";
import { loginSchema } from "./validationSchema";
import { useFormik } from "formik";
import { ValidateUser } from "../../../redux/reducer/ValidateUser";
import { useTheme } from "../../../context/ThemeContext";
import { backgroundPattern } from "../../../config/themes";
import ThemePicker from "../../../components/ThemePicker";

const initialValues = {
  email: "",
  password: "",
};

const LoginUser = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = React.useState(false);
  const [loginError, setLoginError] = React.useState("");
  const [loginSuccess, setLoginSuccess] = React.useState("");
  const { theme } = useTheme();

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const loaderSate = useSelector((state) => state?.loginUser?.loading);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const userType = location?.state?.type;

  const { values, errors, handleBlur, handleChange, touched, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: loginSchema,
      onSubmit: (values, action) => {
        setLoginError("");
        const loginValues = { ...values, type: userType?.toLowerCase() };
        dispatch(UserLogin({ values: loginValues })).then((res) => {
          if (
            res?.payload?.data?.message === "User Login Successfully" &&
            res?.payload?.data?.data?.is_register === true &&
            res?.payload?.data?.data?.is_active === true
          ) {
            sessionStorage.setItem(
              "is_register",
              res?.payload?.data?.data?.is_register
            );
            localStorage.setItem("name", res?.payload?.data?.data?.name);
            localStorage.setItem("is_register", true);
            localStorage.setItem("is_active", true);
            localStorage.setItem("user_id", res?.payload?.data?.data?._id);
            localStorage.setItem("user_email", res?.payload?.data?.data?.email);
            localStorage.setItem("user_type", res?.payload?.data?.data?.type);
            sessionStorage.setItem(
              "ots_token",
              res?.payload?.data?.accessToken
            );
            sessionStorage.setItem("user_id", res?.payload?.data?.data?._id);
            sessionStorage.setItem("name", res?.payload?.data?.data?.name);
            setLoginSuccess("Login successful! Redirecting...");
            dispatch(ValidateUser({}));
            setTimeout(() => {
              if (res?.payload?.data?.data?.type === "landlord") {
                navigate("/landlord-dashboard");
              } else if (res?.payload?.data?.data?.type === "tenant") {
                navigate("/tenant-dashboard");
              }
            }, 2200);
          } else if (
            res?.payload?.data?.data?.code &&
            res?.payload?.data?.data?.is_active === false &&
            res?.payload?.data?.data?.is_register === true
          ) {
            setLoginSuccess("Login successful! Redirecting...");
            sessionStorage.setItem(
              "is_register",
              res?.payload?.data?.data?.is_register
            );
            sessionStorage.setItem("name", res?.payload?.data?.data?.name);
            sessionStorage.setItem("user_id", res?.payload?.data?.data?._id);
            sessionStorage.setItem(
              "user_email",
              res?.payload?.data?.data?.email
            );
            sessionStorage.setItem("code", res?.payload?.data?.data?.code);
            sessionStorage.setItem(
              "ots_token",
              res?.payload?.data?.accessToken
            );
            setTimeout(() => {
              navigate("/pending-request");
            }, 2200);
          } else if (
            res?.payload?.data?.message === "User Login Successfully" &&
            res?.payload?.data?.data?.is_register === false &&
            res?.payload?.data?.data?.is_active === false
          ) {
            setLoginSuccess("Login successful! Redirecting...");
            sessionStorage.setItem(
              "is_register",
              res?.payload?.data?.data?.is_register
            );
            sessionStorage.setItem("name", res?.payload?.data?.data?.name);
            sessionStorage.setItem("user_id", res?.payload?.data?.data?._id);
            sessionStorage.setItem(
              "user_email",
              res?.payload?.data?.data?.email
            );
            sessionStorage.setItem(
              "ots_token",
              res?.payload?.data?.accessToken
            );
            setTimeout(() => {
              if (res?.payload?.data?.data?.type === "landlord") {
                navigate("/property-reg");
              } else if (res?.payload?.data?.data?.type === "tenant") {
                sessionStorage.setItem("code", res?.payload?.data?.data?.code);
                navigate("/tenant-registration");
              }
            }, 2200);
          } else if (
            res?.payload?.data?.message === "User Login Successfully" &&
            res?.payload?.data?.data?.is_register === true &&
            res?.payload?.data?.data?.is_active === false
          ) {
            setLoginSuccess("Login successful! Redirecting...");
            sessionStorage.setItem(
              "is_register",
              res?.payload?.data?.data?.is_register
            );
            sessionStorage.setItem("name", res?.payload?.data?.data?.name);
            sessionStorage.setItem("user_id", res?.payload?.data?.data?._id);
            sessionStorage.setItem(
              "user_email",
              res?.payload?.data?.data?.email
            );
            sessionStorage.setItem(
              "ots_token",
              res?.payload?.data?.accessToken
            );
            setTimeout(() => {
              if (location?.state?.type === "Landlord") {
                navigate("/pending-request");
              }
            }, 2200);
          } else if (res?.payload?.data?.result === "No User Found") {
            setLoginError(res?.payload?.data?.result);
          } else {
            setLoginError(
              res?.payload?.data?.message || "Invalid email or password"
            );
          }
        });
        action.resetForm();
      },
    });

  const handleInputChange = (e) => {
    setLoginError("");
    handleChange(e);
  };

  useEffect(() => {
    location?.state?.type === undefined && navigate("/");
  }, [location?.state?.type, navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: theme.gradient,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        py: 4,
        transition: "background 0.5s ease",
      }}
    >
      {/* Background Pattern */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.1,
          backgroundImage: backgroundPattern,
        }}
      />

      {/* Theme Picker */}
      <ThemePicker position="top-right" light={true} />

      <Container maxWidth="sm" sx={{ position: "relative", zIndex: 1 }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: 4,
            bgcolor: "white",
            boxShadow: "0 25px 80px rgba(0,0,0,0.4)",
          }}
        >
          {/* Logo */}
          <Box sx={{ textAlign: "center", mb: 3 }}>
            {/* <Box
              component="img"
              src={Logo}
              alt="OTS Logo"
              sx={{ height: 60, mb: 2, cursor: "pointer" }}
              onClick={() => navigate("/")}
            /> */}
            <Box
              sx={{
                height: 100,
                width: 100,
                mb: 1,
                display: "inline-block",
                backgroundColor: theme.primary,

                maskImage: `url(${Logo})`,
                WebkitMaskImage: `url(${Logo})`,
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",

                maskSize: "120%",
                WebkitMaskSize: "120%",

                maskPosition: "center",
                WebkitMaskPosition: "center",
              }}
              onClick={() => navigate("/")}
            />
            
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#1a1a2e",
                mb: 1,
              }}
            >
              Welcome to OTS
            </Typography>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                bgcolor: theme.lightBg,
                px: 2,
                py: 0.75,
                borderRadius: 2,
                transition: "all 0.3s ease",
              }}
            >
              <HomeIcon
                sx={{
                  color: theme.primary,
                  fontSize: 20,
                  transition: "color 0.3s ease",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: theme.primary,
                  transition: "color 0.3s ease",
                }}
              >
                {location?.state?.type === 'Landlord' ? 'Property Owner' : location?.state?.type} {" "}
                Login
              </Typography>
            </Box>
          </Box>

          {/* Loader Overlay */}
          {loaderSate && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                bgcolor: "rgba(255,255,255,0.8)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
                borderRadius: 4,
              }}
            >
              <CircularProgress sx={{ color: theme.primary }} />
            </Box>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
              {/* Error Alert */}
              <Collapse in={Boolean(loginError)}>
                <Alert
                  severity="error"
                  onClose={() => setLoginError("")}
                  sx={{
                    borderRadius: 2,
                    "& .MuiAlert-message": {
                      fontWeight: 500,
                    },
                  }}
                >
                  {loginError}
                </Alert>
              </Collapse>

              {/* Success Alert */}
              <Collapse in={Boolean(loginSuccess)}>
                <Alert
                  severity="success"
                  icon={false}
                  sx={{
                    borderRadius: 2,
                    background: `linear-gradient(135deg, ${theme.primary}15 0%, ${theme.secondary}15 100%)`,
                    border: `1px solid ${theme.primary}40`,
                    "& .MuiAlert-message": {
                      fontWeight: 600,
                      color: theme.primary,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      width: "100%",
                      justifyContent: "center",
                    },
                  }}
                >
                  <CircularProgress size={18} sx={{ color: theme.primary }} />
                  {loginSuccess}
                </Alert>
              </Collapse>

              <TextField
                fullWidth
                label="Email Address"
                name="email"
                type="email"
                value={values.email}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={touched.email && Boolean(errors.email)}
                helperText={touched.email && errors.email}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon sx={{ color: "#999" }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    transition: "all 0.3s ease",
                    "&:hover fieldset": { borderColor: theme.primary },
                    "&.Mui-focused fieldset": { borderColor: theme.primary },
                  },
                  "& .MuiInputLabel-root.Mui-focused": { color: theme.primary },
                }}
              />

              <TextField
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={values.password}
                onChange={handleInputChange}
                onBlur={handleBlur}
                error={touched.password && Boolean(errors.password)}
                helperText={touched.password && errors.password}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: "#999" }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    transition: "all 0.3s ease",
                    "&:hover fieldset": { borderColor: theme.primary },
                    "&.Mui-focused fieldset": { borderColor: theme.primary },
                  },
                  "& .MuiInputLabel-root.Mui-focused": { color: theme.primary },
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{
                  mt: 1,
                  py: 1.5,
                  background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.secondary} 100%)`,
                  fontWeight: 600,
                  fontSize: "1rem",
                  borderRadius: 2,
                  textTransform: "none",
                  boxShadow: `0 4px 20px ${theme.primary}50`,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.primaryHover} 0%, ${theme.primary} 100%)`,
                    boxShadow: `0 6px 25px ${theme.primary}70`,
                    transform: "translateY(-2px)",
                  },
                }}
              >
                Login
              </Button>
            </Box>
          </form>

          <Divider sx={{ my: 3 }} />

          {/* Links */}
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="body2" sx={{ color: "#666", mb: 1.5 }}>
              Don't have an account?{" "}
              <Link
                to="/signup"
                state={{ type: userType }}
                style={{
                  color: theme.primary,
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                Sign Up
              </Link>
            </Typography>

            <Typography variant="body2" sx={{ color: "#666" }}>
              Forgot your password?{" "}
              <Link
                to="/forgot-password"
                state={{ type: userType }}
                style={{
                  color: theme.primary,
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                Reset Password
              </Link>
            </Typography>
          </Box>

          {/* Back to Home */}
          <Box sx={{ textAlign: "center", mt: 3 }}>
            <Button
              variant="text"
              onClick={() => navigate("/")}
              sx={{
                color: "#999",
                textTransform: "none",
                "&:hover": { color: theme.primary, bgcolor: "transparent" },
              }}
            >
              Back to Home
            </Button>
          </Box>
        </Paper>

        {/* Footer Text */}
        <Typography
          variant="body2"
          sx={{
            textAlign: "center",
            mt: 3,
            color: "rgba(255,255,255,0.6)",
          }}
        >
          Owner Tenant Solution - Pakistan's #1 Rental Platform
        </Typography>
      </Container>
    </Box>
  );
};

export default LoginUser;
